import * as React from "react";
import {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import {Alert, AppBar, Card} from "@mui/material";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {POST} from "APIclient";
import Snackbar, {SnackbarCloseReason} from "@mui/material/Snackbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {GET} from "APIclient";
import {useLocation} from "react-router-dom";
import {PATCH} from "APIclient";
import properties from "constants/ApplicationConstants";

function CancelOfferLetter(props) {
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(null);
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const handleCloseSnackbar = () => setSnackbar(null);
  const [designationList, setDesignationList] = React.useState([]);
  const [reasonError, setReasonError] = React.useState("");
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = React.useState(false);
  const [formData, setFormData] = React.useState({
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    emailId: "",
    joinDate: dayjs(null),
    joinType: "",
    emailId: "",
    designation: "",
    addedOn: dayjs(null),
    reason: "",
    status: 1
  });

  React.useEffect(() => {
    setUsersState(props);
  }, [props]);

  React.useEffect(() => {
    const fetchUrl = `admin/getIssuedOfferList?offer_id=${usersState}`;
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        const data = response?.data;
        setFormData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [fetch]);

  const validateReason = reason => {
    const regex = /^[A-Za-z\s]*$/;
    if (!reason || reason.trim() === "") {
      return "Reason cannot be empty.";
    }
    if (!regex.test(reason)) {
      return "Reason cannot contain numbers or special characters.";
    }
    return null;
  };

  const handleChange = e => {
    const {name, value} = e.target;

    if (name === "reason") {
      const validationError = validateReason(value);
      if (validationError) {
        setReasonError(validationError);
        setIsSaveButtonEnabled(false);
      } else {
        setReasonError("");
        setIsSaveButtonEnabled(value.trim() !== "");
      }
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;

    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getUrl = `admin/list-designation`;
  const fetchDesignationList = async () => {
    try {
      const response = await GET(getUrl);
      const rawList = response?.data?.data;

      const formattedList = rawList.map(item => {
        let value = "";

        const designation = item.designationName.toLowerCase();

        if (designation === "manager - hr") {
          value = "manager_hr";
        } else if (designation === "operations manager") {
          value = "operations_manager";
        } else if (designation === "senior project manager") {
          value = "senior_project_manager";
        } else if (designation === "hr executive") {
          value = "hr_executive";
        } else if (designation === "qa engineer") {
          value = "qa_engineer";
        } else {
          value = designation.replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "");
        }

        return {
          label: item.designationName,
          value: value
        };
      });

      setDesignationList(formattedList);
    } catch (error) {
      console.error("Error fetching designation list:", error);
    }
  };

  React.useEffect(() => {
    fetchDesignationList();
  }, []);

  const handleSubmit = async () => {
    const reasonValidationError = validateReason(formData?.reason);

    if (reasonValidationError) {
      setReasonError(reasonValidationError);
      return;
    }

    let offerId = formData?.offerLetterId;
    const url = `admin/offer/cancel/${offerId}`;
    try {
      const cancelBody = {
        reason: formData?.reason
      };
      const response = await POST(url, cancelBody);
      if (response?.status === 200) {
        setSnakColor("success");
        setSnakMessage("Offer successfully canceled.");
        setOpen(true);

        setFormData(prevState => ({
          ...prevState,
          reason: ""
        }));

        setReasonError("");
        setIsSaveButtonEnabled(false);
        setTimeout(() => {
          navigate("/Offer_List");
        }, 2000);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "An error occurred while canceling the offer.";
      const statusCode = error?.response?.status;
      setFormData(prevState => ({
        ...prevState,
        reason: ""
      }));
      setSnakColor("error");
      setSnakMessage(`${errorMessage}`);
      setOpen(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={3}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <InputLabel
                sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
                id="offerDate"
              >
                {" "}
                Candidate Information
              </InputLabel>

              {/* <MDInput sx={{ m: 1, width: '10ch' }} name="salutation" value={formData ? formData.salutation : ''} type="text" label="Mr./Mrs." variant="standard" onChange={e => handleChange(e)} /> */}
              <MDInput
                sx={{m: 1, pb: 2, width: "25ch"}}
                name="firstName"
                value={formData ? formData.firstName : ""}
                type="text"
                label="First Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />
              <MDInput
                sx={{m: 1, width: "25ch"}}
                name="middleName"
                value={formData ? formData.middleName : ""}
                type="text"
                label="Middle Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />
              <MDInput
                sx={{m: 1, width: "25ch"}}
                name="lastName"
                value={formData ? formData.lastName : ""}
                type="text"
                label="Last Name"
                variant="standard"
                onChange={e => handleChange(e)}
                InputProps={{readOnly: true}}
              />

              <MDInput
                sx={{width: "30ch"}}
                type="email"
                name="emailId"
                value={formData ? formData.emailId : ""}
                inputProps={{pattern: "/^[w-.]+@([w-]+.)+[w-]{2,4}$/g"}}
                onChange={e => handleChange(e)}
                label="Email"
                variant="standard"
                InputProps={{readOnly: true}}
              />
              <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                <InputLabel id="joinType">Designation</InputLabel>
                <Select
                  value={formData ? formData.designation : ""}
                  name="designation"
                  label="Designation"
                  onChange={e => handleChange(e)}
                  IconComponent={ExpandMoreIcon}
                  disabled
                  sx={{
                    "& .MuiSelect-select": {
                      color: "#000"
                    },
                    "&.Mui-disabled .MuiSelect-select": {
                      color: "#000",
                      WebkitTextFillColor: "#000"
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                      opacity: 1
                    }
                  }}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {designationList?.map(designation => (
                    <MenuItem key={designation.value} value={designation.value}>
                      {designation.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "Select"]} sx={{marginTop: "10px"}}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    sx={{m: 1, width: "30ch"}}
                    size="small"
                    label="Joining Date"
                    name="joinDate"
                    value={formData ? dayjs(formData.joinDate) : null}
                    onChange={date => handleDateChange(date, "joinDate")}
                    readOnly
                  />
                </DemoContainer>
              </LocalizationProvider>
              <MDInput
                sx={{m: 1, width: "40ch"}}
                multiline
                maxRows={4}
                type="text"
                name="reason"
                value={formData?.reason}
                onChange={e => handleChange(e)}
                label={
                  <>
                    Reason <span style={{color: properties.colors.Red}}>*</span>
                  </>
                }
                variant="standard"
                helperText={reasonError}
                error={!!reasonError}
              />
            </MDBox>

            <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
              <MDBox sx={{display: "flex", gap: 2}}>
                <MDButton
                  variant="gradient"
                  color="warning"
                  sx={{width: "25ch"}}
                  onClick={() => navigate(-1)}
                >
                  Back
                </MDButton>
                <MDButton
                  variant="gradient"
                  color="info"
                  sx={{
                    marginRight: "10px",
                    width: "25ch",
                    fontFamily: properties.fontFamily,
                    background: properties.colors.bgcolorbluethem
                  }}
                  onClick={() => handleSubmit()}
                  disabled={!isSaveButtonEnabled}
                >
                  Cancel Offer
                </MDButton>
              </MDBox>
            </MDBox>
            <Snackbar
              open={open}
              anchorOrigin={{vertical: "top", horizontal: "right"}}
              autoHideDuration={6000}
              onClose={handleClose}
            >
              <Alert
                autoHideDuration={1200}
                onClose={handleClose}
                close={handleClose}
                severity={snakColor == "success" ? "success" : "error"}
                variant="filled"
                sx={{width: "100%"}}
              >
                {snakMessage}
              </Alert>
            </Snackbar>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
export default CancelOfferLetter;
